module.exports = __webpack_public_path__ + "static/media/Misha Steinhauer.40fca14e.jpg";